import React from 'react'
import { PoweredBy } from 'react-instantsearch/dom'
import styled from 'styled-components'

export const FooterWrapper = styled.div`
  width: 100%;
  height: 60px;
  background-color: ${props => props.theme.appBackground};
  > .ais-PoweredBy {
    float: right;
    margin-right: 20px;
  }
`

export default () => (
  <FooterWrapper>
    <PoweredBy />
  </FooterWrapper>
)
